/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessLineResponseDto
 */
export interface BusinessLineResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BusinessLineResponseDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BusinessLineResponseDto
     */
    name: BusinessLineResponseDtoNameEnum;
    /**
     * 
     * @type {string}
     * @memberof BusinessLineResponseDto
     */
    placingType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessLineResponseDto
     */
    isActive: boolean;
}


/**
 * @export
 */
export const BusinessLineResponseDtoNameEnum = {
    Property: 'Property',
    Power: 'Power',
    OnshoreEnergy: 'Onshore Energy',
    CrisisManagement: 'Crisis Management',
    Casualty: 'Casualty',
    ProfessionalLines: 'Professional Lines'
} as const;
export type BusinessLineResponseDtoNameEnum = typeof BusinessLineResponseDtoNameEnum[keyof typeof BusinessLineResponseDtoNameEnum];


/**
 * Check if a given object implements the BusinessLineResponseDto interface.
 */
export function instanceOfBusinessLineResponseDto(value: object): value is BusinessLineResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function BusinessLineResponseDtoFromJSON(json: any): BusinessLineResponseDto {
    return BusinessLineResponseDtoFromJSONTyped(json, false);
}

export function BusinessLineResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessLineResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'placingType': json['placingType'] == null ? undefined : json['placingType'],
        'isActive': json['isActive'],
    };
}

export function BusinessLineResponseDtoToJSON(json: any): BusinessLineResponseDto {
    return BusinessLineResponseDtoToJSONTyped(json, false);
}

export function BusinessLineResponseDtoToJSONTyped(value?: BusinessLineResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'placingType': value['placingType'],
        'isActive': value['isActive'],
    };
}

